module.exports = __webpack_public_path__ + "img/banner-10-zh.13a622b9.png";